import { render, staticRenderFns } from "./Departments.vue?vue&type=template&id=29386d94&scoped=true&"
import script from "./Departments.vue?vue&type=script&lang=ts&"
export * from "./Departments.vue?vue&type=script&lang=ts&"
import style0 from "./Departments.vue?vue&type=style&index=0&id=29386d94&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29386d94",
  null
  
)

export default component.exports